import React, {Component} from 'react';

import moment from 'moment';

//css
import styles from '../../static/css/componentStyleModules/thanksCardList.module.scss';

import FaceIconBaseComponent from '../faceIconComponents/FaceIconBaseComponent.js';
import ThanksButtonComponent from './ThanksButtonComponent';

export default class ThanksCardListComponent extends Component{

    constructor(props) {
        super(props)
        this.state = {

        }
    }

    cardClickAction = (cardData) => {        
        this.props.onCardClick(cardData);
    }

    cardTouchStart = (event) => { 
        const currentCard = event.currentTarget;

        currentCard.classList.add(styles['clicked']);
    }

    cardTouchEnd = (event) => {        
        const currentCard = event.currentTarget;

        currentCard.classList.remove(styles['clicked']);
    }


    render() {
        const thanksCardComponent = (card,index) => {

            const thanksDate = (dateIntStr) => {
                if(dateIntStr !== undefined){
                    const dateString = moment(dateIntStr).format('YYYY年MM月DD日')
                    
                    return dateString;
                }else{
                    return '';
                }
            }


            return (
                <div className={styles['thanksCard'] + ' thanksLogCard'} 
                key={card.Thanks.id}
                id={'thanksListCard_' + card.Thanks.id}
                onClick={() => this.cardClickAction(card)}
                onTouchStart={this.cardTouchStart}
                onTouchEnd={this.cardTouchEnd}
                >
                  <div className={styles['iconArea']}>
                    <FaceIconBaseComponent 
                    head={card.Members.head !== null ? card.Members.head : 'basic'} 
                    eyes={card.Members.eyes !== null ? card.Members.eyes : 'basic'} 
                    eyeblows={card.Members.eyeblows !== null ? card.Members.eyeblows : 'none'} 
                    mouth={card.Members.mouth !== null ? card.Members.mouth : 'basic'} 
                    fillColor={card.Members.color !== null ? card.Members.color : '#888888'} />
                  </div>
                  <div className={styles['infoArea']}>
                    <div className={styles['subInfoRack']}>
                       <div className={styles['memberName']}>
                         {card.Members.name !== null ? card.Members.name : 'ななしさん'}
                       </div>
                       <div className={styles['thanksDate']}>{thanksDate(card.Thanks.date)}</div>
                    </div>
                    <h2>{card.Thanks.title}</h2>
                  </div>
                  <div className={styles['buttonArea']} >
                    <ThanksButtonComponent 
                    thankData={card.Thanks}
                    type="round"
                    status={card.Thanks.check}
                    onRewriteBackData={(data) => this.props.onRewriteBackData(data,index)}
                     />
                  </div>
                </div>
            )
        };

        return (
            <div>
              {this.props.thanksList.map(thanksCardComponent)}
            </div>
        )
    }
}